<template>
  <div class="visit-menu-configuration-list">
    <vx-card title="Visit Menu Configuration" class="visit-menu-list-card">
      <div class="list-toolbar mb-4">
        <vs-button
          color="primary"
          icon-pack="feather"
          icon="icon-plus"
          @click="handleCreate"
        >
          Create
        </vs-button>
      </div>

      <h6 class="mb-3">Saved Configuration</h6>

      <vs-table
        search
        stripe
        border
        :sst="true"
        :data="table.data"
        :max-items="table.length"
        :total="table.total"
        @search="handleSearch"
        @change-page="handleChangePage"
        @sort="handleSort"
      >
        <template slot="header">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2">
                {{ table.start }} - {{ table.end }} of {{ table.total }}
              </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item
                v-for="item in table.limits"
                :key="item"
                @click="handleChangeLength(item)"
              >
                <span>{{ item }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </template>

        <template slot="thead">
          <vs-th class="th-no">No.</vs-th>
          <vs-th sort-key="config_name">Configuration Setting Name</vs-th>
          <vs-th sort-key="territory_name">Territory</vs-th>
          <vs-th sort-key="role_name">Role User</vs-th>
          <vs-th sort-key="subtype_name">Salesman Subtype</vs-th>
          <vs-th sort-key="last_update">Last Updated</vs-th>
          <vs-th sort-key="updated_by_name">Updated By</vs-th>
          <vs-th class="th-action">Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ rowNumber(indextr) }}</vs-td>
            <vs-td>{{ tr.config_name || "-" }}</vs-td>
            <vs-td>{{ tr.territory_name || "-" }}</vs-td>
            <vs-td>{{ tr.role_name || "-" }}</vs-td>
            <vs-td>{{ tr.subtype_name || "-" }}</vs-td>
            <vs-td>{{ formatIndoDateTime(tr.last_update) }}</vs-td>
            <vs-td>{{ tr.updated_by_name || "-" }}</vs-td>
            <vs-td>
              <div class="action-btns">
                <vs-button
                  v-if="hasAllowedAction(tr, 'view')"
                  @click.stop="handleView(tr)"
                  size="small"
                  type="flat"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-eye"
                  title="View"
                />
                <vs-button
                  v-if="hasAllowedAction(tr, 'edit')"
                  @click.stop="handleEdit(tr)"
                  size="small"
                  type="flat"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-edit-2"
                  title="Edit"
                />
                <vs-button
                  v-if="hasAllowedAction(tr, 'delete')"
                  @click.stop="handleDelete(tr)"
                  size="small"
                  type="flat"
                  color="danger"
                  icon-pack="feather"
                  icon="icon-trash"
                  title="Delete"
                />
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <p v-if="!table.data.length && !loading" class="empty-hint mt-4">
        No saved configuration found.
      </p>
    </vx-card>
  </div>
</template>

<script>
const SETTINGS_URL = "/api/sfa/v1/visit-task/configuration/settings";

const INDO_MONTHS = [
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember",
];

function pad2(value) {
  return String(value).padStart(2, "0");
}

export default {
  name: "VisitMenuConfigurationList",
  data() {
    return {
      loading: false,
      searchTimeout: null,
      table: {
        data: [],
        total: 0,
        totalPage: 0,
        length: 10,
        start: 0,
        end: 0,
        limits: [5, 10, 25, 50, 100],
        query: "",
        page: 1,
        order: "",
        sort: "",
      },
    };
  },
  methods: {
    isApiSuccess(resp) {
      return (
        resp &&
        (resp.code === 200 ||
          resp.status === "success" ||
          resp.status === "OK")
      );
    },
    rowNumber(index) {
      return (this.table.page - 1) * this.table.length + index + 1;
    },
    hasAllowedAction(row, action) {
      return (
        Array.isArray(row.allowed_actions) &&
        row.allowed_actions.includes(action)
      );
    },
    formatIndoDateTime(value) {
      if (!value) return "-";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "-";
      const day = date.getDate();
      const month = INDO_MONTHS[date.getMonth()];
      const year = date.getFullYear();
      return `${day} ${month} ${year} ${pad2(date.getHours())}:${pad2(
        date.getMinutes()
      )}`;
    },
    loadList() {
      this.loading = true;
      this.$vs.loading();
      this.$http
        .get(SETTINGS_URL, {
          params: {
            page: this.table.page,
            length: this.table.length,
            search: this.table.query,
            order: this.table.order,
            sort: this.table.sort,
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          this.loading = false;
          if (this.isApiSuccess(resp) && resp.data) {
            const records = Array.isArray(resp.data.records)
              ? resp.data.records
              : [];
            this.table.data = records;
            this.table.total = resp.data.total_record || 0;
            this.table.totalPage = resp.data.total_page || 0;
            this.table.start =
              this.table.total === 0
                ? 0
                : (this.table.page - 1) * this.table.length + 1;
            this.table.end = this.table.start + records.length - 1;
          } else {
            this.table.data = [];
            this.table.total = 0;
            this.table.start = 0;
            this.table.end = 0;
            this.notifyError(resp.message || "Failed to load configurations");
          }
        })
        .catch(() => {
          this.$vs.loading.close();
          this.loading = false;
          this.table.data = [];
          this.table.total = 0;
          this.notifyError("Failed to load configurations");
        });
    },
    handleSearch(query) {
      this.table.query = query;
      this.table.page = 1;
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.loadList();
      }, 400);
    },
    handleChangePage(page) {
      this.table.page = page;
      this.loadList();
    },
    handleChangeLength(length) {
      this.table.length = length;
      this.table.page = 1;
      this.loadList();
    },
    handleSort(key, active) {
      this.table.order = key || "";
      this.table.sort = active || "";
      this.table.page = 1;
      this.loadList();
    },
    buildScopeQuery(row) {
      return {
        config_name: row.config_name,
        territory_id: row.territory_id,
        territory_name: row.territory_name,
        role_id: row.role_id,
        role_name: row.role_name,
        work_position_id: row.work_position_id,
        subtype_name: row.subtype_name,
      };
    },
    handleCreate() {
      this.$router.push({ name: "visit-menu-configuration-create" });
    },
    handleView(row) {
      this.$router.push({
        name: "visit-menu-configuration-view",
        params: { id: String(row.id) },
        query: this.buildScopeQuery(row),
      });
    },
    handleEdit(row) {
      this.$router.push({
        name: "visit-menu-configuration-edit",
        params: { id: String(row.id) },
        query: this.buildScopeQuery(row),
      });
    },
    handleDelete(row) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: `Please confirm to delete configuration "${row.config_name}"`,
        accept: () => this.acceptDelete(row),
      });
    },
    acceptDelete(row) {
      this.$vs.loading();
      this.$http
        .delete(SETTINGS_URL, { params: { config_name: row.config_name } })
        .then((resp) => {
          this.$vs.loading.close();
          if (this.isApiSuccess(resp)) {
            this.$vs.notify({
              title: "Success",
              text: resp.message || "Configuration deleted successfully",
              color: "success",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
            if (this.table.data.length === 1 && this.table.page > 1) {
              this.table.page -= 1;
            }
            this.loadList();
          } else {
            this.notifyError(resp.message || "Failed to delete configuration");
          }
        })
        .catch(() => {
          this.$vs.loading.close();
          this.notifyError("Failed to delete configuration");
        });
    },
    notifyError(text) {
      this.$vs.notify({
        title: "Error",
        text,
        color: "danger",
        position: "top-right",
      });
    },
  },
  mounted() {
    this.loadList();
  },
};
</script>

<style scoped>
.list-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-btns {
  display: flex;
  align-items: center;
  gap: 4px;
}

.th-no {
  width: 64px;
}

.th-action {
  width: 140px;
}

.empty-hint {
  color: rgba(var(--vs-text), 0.6);
  font-size: 14px;
}
</style>
